/** @format */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfCheckboxComponent } from '@dsg-tech/homefield-angular';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'plp-components-compare-checkbox',
	imports: [CommonModule, HmfCheckboxComponent],
	templateUrl: './compare-checkbox.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareCheckboxComponent {
	@Input() checked = false;

	@Output() check = new EventEmitter<boolean>();

	onCompareChange(isChecked: boolean): void {
		this.check.emit(isChecked);
	}
}
